import { Directive, inject, input, TemplateRef } from '@angular/core';
import { CfgCellContext } from './table-column.model';

/**
 * Marks an `ng-template` as the custom cell for a cfg-table column:
 *
 * ```html
 * <ng-template cfgCell="status" [cfgCellOf]="rows()" let-row let-value="value">
 *   <button (click)="retry(row)">Prøv igen</button>
 * </ng-template>
 * ```
 *
 * `cfgCellOf` is a pure type anchor: bind the same array the table renders and the
 * template context (`let-row`) is inferred as the row type. It is never read at runtime.
 */
@Directive({ selector: 'ng-template[cfgCell]' })
export class CfgCellDirective<T> {
  /** Column key this template overrides. */
  readonly cfgCell = input.required<string>();
  /** Type anchor only — pass the rendered rows so T is inferred. Never read at runtime. */
  readonly cfgCellOf = input<readonly T[] | undefined>(undefined);

  readonly templateRef = inject(TemplateRef) as TemplateRef<CfgCellContext<T>>;

  static ngTemplateContextGuard<T>(dir: CfgCellDirective<T>, ctx: unknown): ctx is CfgCellContext<T> {
    return true;
  }
}
